module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_hazel.3e6d5a10.png";